var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExchange = function SvgExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#335EEA",
    opacity: 0.3,
    transform: "rotate(-90 13 6)",
    x: 12,
    width: 2,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.707 8.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L7.414 6l2.293 2.293z",
    fill: "#335EEA"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#335EEA",
    opacity: 0.3,
    transform: "matrix(0 -1 -1 0 29 29)",
    x: 10,
    y: 12,
    width: 2,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.293 20.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 0 0-1.414 1.414L16.586 18l-2.293 2.293z",
    fill: "#335EEA"
  }))));
};

export { SvgExchange as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48cmVjdCBmaWxsPSIjMzM1RUVBIiBvcGFjaXR5PSIuMyIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIDEzIDYpIiB4PSIxMiIgd2lkdGg9IjIiIGhlaWdodD0iMTIiIHJ4PSIxIi8+PHBhdGggZD0iTTkuNzA3IDguMjkzYTEgMSAwIDAxLTEuNDE0IDEuNDE0bC0zLTNhMSAxIDAgMDEwLTEuNDE0bDMtM2ExIDEgMCAwMTEuNDE0IDEuNDE0TDcuNDE0IDZsMi4yOTMgMi4yOTN6IiBmaWxsPSIjMzM1RUVBIi8+PHJlY3QgZmlsbD0iIzMzNUVFQSIgb3BhY2l0eT0iLjMiIHRyYW5zZm9ybT0ibWF0cml4KDAgLTEgLTEgMCAyOSAyOSkiIHg9IjEwIiB5PSIxMiIgd2lkdGg9IjIiIGhlaWdodD0iMTIiIHJ4PSIxIi8+PHBhdGggZD0iTTE0LjI5MyAyMC4yOTNhMSAxIDAgMDAxLjQxNCAxLjQxNGwzLTNhMSAxIDAgMDAwLTEuNDE0bC0zLTNhMSAxIDAgMDAtMS40MTQgMS40MTRMMTYuNTg2IDE4bC0yLjI5MyAyLjI5M3oiIGZpbGw9IiMzMzVFRUEiLz48L2c+PC9zdmc+";